import type { SVGProps } from "react";

export function IconBlueArrows(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 4.25H12.25H9.5C5.21979 4.25 1.75 7.71979 1.75 12C1.75 13.8706 2.41271 15.5864 3.51614 16.9254L4.71773 16.0242C3.80185 14.9369 3.25 13.5329 3.25 12C3.25 8.54822 6.04822 5.75 9.5 5.75L10.25 5.75L14 5.75C14 5.24976 14 4.75202 14 4.25ZM19.2822 7.97576L20.4838 7.07458C21.5873 8.41361 22.25 10.1294 22.25 12C22.25 16.2802 18.7802 19.75 14.5 19.75H12.75L10 19.75V18.25L12.75 18.25H14.5H14.75V18.2451C18.0859 18.1139 20.75 15.3681 20.75 12C20.75 10.4671 20.1981 9.06305 19.2822 7.97576Z"
        fill="white"
      />
      <path
        d="M10 16L6 19L10 22L10 16Z"
        fill="#5486FA"
        stroke="#5486FA"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M14 2L18 5L14 8L14 2Z"
        fill="#5486FA"
        stroke="#5486FA"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
